const isDateOptionEqual = (a: DateOption, b: DateOption) =>
  a.value.startDate === b.value.startDate &&
  a.value.endDate === b.value.endDate;

export default isDateOptionEqual;
